export default {
  successMessage: 'Successfully registered.',
  successButtonLabel: 'Great!',
}
